export const DASHBOARD_MODULE_SECTION_IDS = {
    lead: ['lead'],
    proposal: ['proposte', 'accettate', 'maturato'],
    listing: ['listing'],
    advertisingCost: ['costs'],
    areaSource: ['budget'],
    source: ['budget'],
    biIntegrated: [],
};

export const getSectionIdsForDashboardModule = (moduleKey) => {
    const value = DASHBOARD_MODULE_SECTION_IDS[moduleKey];
    return Array.isArray(value) ? value : [];
};
